import React from 'react';
import { IAddCertificateProps, IUpdateCertificateProps } from '../../redux/models/expert';
import { connect } from 'react-redux';
import { Certificate, Card } from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useLocalErrorHandler } from 'hooks';
import { push } from 'connected-react-router';

const RegistrationCompletionContainer = ({
    getCertificateList,
    certificateList,
    apiError,
    setErrorHandler,
    addCertificate,
    deleteCertificate,
    updateCertificate,
    onPush,
}: Props) => {
    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await getCertificateList();
            setProcessing(false);
        };

        fetch();

        return () => {
            setProcessing(false);
        };
    }, []);

    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    const onChange = async (data: IUpdateCertificateProps) => {
        const res = await updateCertificate(data);

        return !!res;
    };

    const onCreate = async (data: IAddCertificateProps) => {
        const res = await addCertificate(data);

        return !!res;
    };

    const onSuccess = () => onPush('/participation-requests');

    return (
        <Card
            title="Добавление свидетельства члена комиссии"
            cardClassName="border-0"
            apiError={apiError}
            showLoader={processing}
            withoutPadding
        >
            <Certificate
                onChange={(certificateId, certificateData) => onChange({ certificateId, certificateData })}
                onCreate={certificateData => onCreate({ certificateData })}
                onDelete={certificateId => deleteCertificate({ certificateId })}
                certificateList={certificateList}
                apiError={apiError}
                onSuccess={onSuccess}
                withoutCardHeader
                onlyChange
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    certificateList: state.expert.certificateList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    fetchProfile: dispatch.auth.fetchProfile,
    getCertificateList: dispatch.expert.getCertificateListAsync,
    addCertificate: dispatch.expert.addCertificateAsync,
    deleteCertificate: dispatch.expert.deleteCertificateAsync,
    updateCertificate: dispatch.expert.updateCertificateAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(RegistrationCompletionContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;
